import { REVIEW } from '@sonder/shared'
import { ButtonLink, Hero } from '@/ui'
import { TopBar } from './TopBar'
import type { PageProps } from './ClientRoutes'

export function SubmittedPage({ client, base }: Omit<PageProps, 'config'>) {
  return (
    <>
      <TopBar clientName={client.name} section="Submitted" homeHref={base} />
      <main id="main">
        <Hero eyebrow="Onboarding" title={REVIEW.doneTitle} actions={<ButtonLink to={`${base}/onboarding`} variant="inverse" arrow={false}>Back to your answers</ButtonLink>}>
          <p>{REVIEW.doneBody}</p>
        </Hero>
      </main>
    </>
  )
}
